var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-dialog-white-mask"},[_c('div',{staticClass:"vx-loading",class:['vx-loading-'+_vm.type]},[_c('div',{staticClass:"vx-loading-icon"}),_c('div',{staticClass:"vx-loading-txt",domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }